import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import it from "./locales/it.json";
import en from "./locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { it: { translation: it }, en: { translation: en } },
    // fallback inglese se l'utente non è italiano
    fallbackLng: "en",
    // Logica di detection: prima localStorage (scelta manuale dell'utente),
    // poi navigator.language. Se navigator dice "it*" → it, altrimenti en.
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "ah_lang",
      caches: ["localStorage"],
      // Normalizza qualsiasi "it-*" in "it", qualsiasi altro in "en"
      convertDetectedLanguage: (lng) => (lng && lng.toLowerCase().startsWith("it") ? "it" : "en"),
    },
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

export default i18n;
